import { render, staticRenderFns } from "./CheckboxDictInput.vue?vue&type=template&id=2ec3e5c6&"
import script from "./CheckboxDictInput.vue?vue&type=script&lang=js&"
export * from "./CheckboxDictInput.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxDictInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
